// 위치 이용 안내창 (치과 찾기·기공소 찾기·재제작 상담 공용) — 2026-09-16
// 문구 정본: docs/위치기반서비스_이용약관_v1.1_게시본_2026-09-16.md §5 · docs/환자동의_문안_cp-1.4_정본_2026-09-16.md 부록 D-3.
// 문구 변경 시 법적보안 확인. [동의하고 찾기]를 누른 경우에만 브라우저 위치를 요청한다(체크 없이는 진행 불가).
import React, { useState } from 'react';
import { LOCATION_AGE_HINT, LOCATION_USE_LOG_ENABLED } from '../../utils/locationConsent';

const LEAD = '주식회사 덴탈클러스터는 가까운 곳을 거리순으로 보여 드리기 위해 현재 위치를 이용합니다.';
const STORE_LINE = LOCATION_USE_LOG_ENABLED
    ? '보관: 회사는 위치를 저장하지 않습니다. 법에서 정한 이용 기록(위치·접속 정보 제외)만 6개월 보관합니다.'
    : '보관: 회사는 위치를 저장하지 않습니다.';
const ITEMS = [
    '이용하는 정보: 이 기기의 현재 위치(약 100m 단위로 줄인 좌표)',
    '이용 목적: 현재 위치를 기준으로 한 주변 검색·거리순 정렬, 지도 표시',
    '전달: 검색은 회사 서버를 거쳐, 지도 표시는 이 브라우저에서 직접 주식회사 카카오에 전달됩니다(지도에 보이는 영역의 위치 포함).',
    STORE_LINE,
    '동의하지 않아도 지역명·이름으로 찾거나 지도를 옮겨 찾을 수 있습니다.',
    '동의 여부는 이 브라우저에만 저장됩니다. 이 페이지 하단 [위치 이용 동의 철회] 또는 브라우저 설정의 위치 권한 끄기로 언제든지 철회할 수 있습니다.',
];

// props: title(화면 이름), onAgree(만 14세 확인 후), onDecline
function LocationConsentModal({ title = '현재 위치로 찾기', onAgree, onDecline }) {
    const [age14, setAge14] = useState(false);
    const [hint, setHint] = useState('');

    const agree = () => {
        if (!age14) { setHint(LOCATION_AGE_HINT); return; }
        onAgree();
    };

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 460, maxHeight: '85vh', overflow: 'auto', padding: 20 }}>
                <h3 style={{ margin: '0 0 10px', fontSize: 16, fontWeight: 800, color: '#0f172a' }}>{title}</h3>
                <div style={{ fontSize: 13, color: '#334155', lineHeight: 1.7 }}>
                    <p style={{ margin: '0 0 8px' }}>{LEAD}</p>
                    <ul style={{ margin: '0 0 8px', paddingLeft: 18 }}>
                        {ITEMS.map((t) => <li key={t}>{t}</li>)}
                    </ul>
                    <a href="/location-terms" target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: '#475569', textDecoration: 'underline' }}>
                        위치기반서비스 이용약관 전문 보기
                    </a>
                </div>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 14, fontSize: 14, color: '#0f172a', cursor: 'pointer' }}>
                    <input type="checkbox" checked={age14} onChange={(e) => { setAge14(e.target.checked); setHint(''); }} />
                    만 14세 이상입니다
                </label>
                {hint && <div style={{ marginTop: 8, fontSize: 12, color: '#b45309' }}>{hint}</div>}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
                    <button type="button" onClick={onDecline} style={{ padding: '9px 14px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
                        지역으로 찾기
                    </button>
                    <button type="button" onClick={agree} style={{ padding: '9px 16px', background: '#10b981', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer', opacity: age14 ? 1 : 0.6 }}>
                        동의하고 찾기
                    </button>
                </div>
            </div>
        </div>
    );
}

export default LocationConsentModal;
